module.exports = __webpack_public_path__ + "img/iPhone 11 - Pro.45e5a482.png";